import React, { useEffect, useState, Fragment} from "react";
import { useFormik } from 'formik';
import Datepicker from "../../component/Datepicker/Datepicker";
import Interests, {InterestFilterSelected} from "../../component/Interests/Interests";
import { useFilePicker } from 'use-file-picker';
import { popinfo } from "../../component/Fancybox/Fancybox";
import { QuillBuilder } from "../../component/RichEditor/RichEditor"
import EditEventForm from "../../component/EditEvent";
import EditResearchForm from "../../component/EditResearch";
import BlockHeader from "component/BlockHeader/BlockHeader";
import { format } from 'date-fns';
import { connect } from 'react-redux';
import fancybox from "../Fancybox/Fancybox";
import stateMap from "../../store/stateMap";
import Slugify from "slugify";
import api from '../../api';
import _ from 'lodash';
import update from "immutability-helper";
import "../../sass/form/form.scss";

const EditInitiativeForm = connect(stateMap)(props => {
    const [openFileSelector, { filesContent, plainFiles, clear, errors }] = useFilePicker({
        readAs: 'DataURL',
        accept: ['image/png', 'image/jpg', 'image/jpeg'],
        multiple: false,
        limitFilesConfig: { max: 1 },
        maxFileSize: 2
    });

    const [managedPages, setManagedPages]           = useState([]);

    const [toProposedPages, setToProposedPages]     = useState([]);

    const [selectedPages, setSelectedPages] = useState([]);

    const [selectedProposedPages, setSelectedProposedPages] = useState([]);

    const [initiative, setInitiative] = useState(props.sentInitiative);

    const [updatedSelectedInterest, setUpdatedSelectedInterest]  = useState(false);

    const [formDataLoad, setFormDataLoad] = useState(true);

    const [initiativeInterests, setInitiativeInterests] = useState(false);

    const [slugLoading, setSlugLoading] = useState(false);

    const [descriptionWYSIWYG, setDescriptionWYSIWYG] = useState(false);

    const formik = useFormik({
        initialValues: {
            InitiativeID : initiative.ID || ''
            ,Title : ''
            ,Slug : ''
            ,StartDate : format(new Date(), 'y-MM-dd')
            ,EndDate : format(new Date(), 'y-MM-dd')
            ,ScopeLevel : ''
            ,PosterImage : ''
            ,EnableMultirole : initiative.EnableMultirole || 1
            ,InitiativeType : initiative.InitiativeType || props.InitiativeType
        }
        ,onSubmit: values => {

            if(slugLoading)
            {
                return popinfo('error', 'Oopss', 'Please Wait URL Identifier load');
            }
            
            let SavingLoader = popinfo('loader', 'Saving Initiative', 'Thank you for creating with Crowdbees');


            api('/Initiative', 'post', _.assignIn({}, values, {
                Description : descriptionWYSIWYG.root.innerHTML
            }) , 'Bearer ' + props.auth.token)
                .then(function(response){
                    
                    settingFormValues(response.initiative);

                    popinfo('loader', 'Saving Exciting Information', 'Interest &amp; Poster make your initiative looks better', {}, SavingLoader);
               
                    var ExtraBasicInfo = [
                        api('/InitiativeInterest', 'post', {
                            'InitiativeID'      : response.initiative.InitiativeID
                            ,'interest'         : InterestFilterSelected(updatedSelectedInterest)
                        }, 'Bearer ' + props.auth.token)
                    ];

                    if(filesContent.length > 0)
                    {
                        ExtraBasicInfo.push(
                            api('/InitiativePoster', 'post', {
                                'InitiativeID'      : response.initiative.InitiativeID
                                ,'imageData'        : filesContent[0].content
                                ,'imageName'        : filesContent[0].name
                            }, 'Bearer ' + props.auth.token)
                        );
                    }

                    api('/InitiativePages', 'post', {
                        'InitiativeID'      : response.initiative.InitiativeID
                        ,'pages'            : selectedPages
                    }, 'Bearer ' + props.auth.token)
                    
                    api('/InitiativeProposeToPages', 'post', {
                        'InitiativeID'      : response.initiative.InitiativeID
                        ,'pages'            : selectedProposedPages
                    }, 'Bearer ' + props.auth.token)

                    Promise.all(ExtraBasicInfo)
                        .then(() => {
                            SavingLoader.close();

                            props.onSave(response.initiative);                        
 
                        })    
                        .catch((err) => {
                        
                            popinfo('error', 'Ooppss..', err, {}, SavingLoader);
                        })
                        
                        
                })
                .catch((error) => {
                    popinfo('error', 'Saving Data', error, {}, SavingLoader);
                });
        }
    });

    const settingFormValues = (formData) => {
        _.each(formData, (value, attribute) => {
            if(value === null)
            {
                value = '';
            }

            if(( attribute == 'StartDate' || attribute == 'EndDate' ) && value == '')
            {
                
                value = format(new Date(), 'y-MM-dd');
            }

            if(attribute == 'Description')
            {
                descriptionWYSIWYG.setContents(descriptionWYSIWYG.clipboard.convert(value), 'silent');
            }
            
            formik.setFieldValue(attribute, value);

        });
    }

    const correctingEligibleSlug = (Slug) => {
        setSlugLoading(true);

        var slug = Slugify(Slug, {
            lower : true
            ,strict : true
        });

        api('/IsInitiativeSlugEligible', 'get', {
            'Slug'              : slug
            ,'InitiativeID'     : formik.values.InitiativeID
        }, 'Bearer ' + props.auth.token)
            .then((response) => {
                
                setSlugLoading(false);
                
                formik.setFieldValue('Slug', response.slug);
            })
            .catch((error) => {
                setSlugLoading(false);

                formik.setFieldValue('Slug', '');
            });
    }

    useEffect(() => {

        if(descriptionWYSIWYG === false)
        {
            var rte = QuillBuilder(document.getElementById('initiative-description'), props.auth.token);
    
            rte.once('editor-change', () => {
                setDescriptionWYSIWYG(rte);
            });
    
            rte.setText('\n', 'silent');
        }
    }, []);

    useEffect(() => {
        if(initiative.InitiativeID != props.sentInitiative.InitiativeID)
        {
            setInitiative(props.sentInitiative);
        }
    }, [props.sentInitiative]);

    useEffect(()=>{

        if(descriptionWYSIWYG === false)
        {
            return;
        }

        setFormDataLoad(true);

        // Get User Managed Page
        let DataToLoad = [
            api('/Pages', 'get', {
                has_access : 1
            }, 'Bearer ' + props.auth.token)
            ,api('/Pages', 'get', {
                has_access : 0
                ,is_official : 1
            }, 'Bearer ' + props.auth.token)
        ];


        if(initiative.InitiativeID > 0)
        {
            DataToLoad.push(
                api('/InitiativeInterest', 'get', {
                    InitiativeID : initiative.InitiativeID
                }, 'Bearer ' + props.auth.token)
                ,api('/InitiativePages', 'get', {
                    InitiativeID : initiative.InitiativeID
                }, 'Bearer ' + props.auth.token)
                ,api('/InitiativeProposeToPages', 'get', {
                    InitiativeID : initiative.InitiativeID
                }, 'Bearer ' + props.auth.token)
            );

            Promise.all(DataToLoad)
                .then((response) => {

                    setInitiativeInterests(_.map(response[2].interest, (interest) => {
                        interest.isSelected = 1;

                        return interest;

                    }));

                    setSelectedPages(_.map(response[3].page, 'PageID'));

                    setSelectedProposedPages(_.map(response[4].page, 'PageID'))

                    setManagedPages(response[0].page);

                    setToProposedPages(response[1].page);

                    settingFormValues(initiative);

                    setFormDataLoad(false);
                })
        }
        else
        {
            Promise.all(DataToLoad)
                .then((response) => {
                    setManagedPages(response[0].page);

                    setToProposedPages(response[1].page);

                    setInitiativeInterests([]);
        
                    setFormDataLoad(false);
                });
        }
    }, [descriptionWYSIWYG]);

    return (
        <form className="generic-form"  onSubmit={formik.handleSubmit}>
            <div className="form-group">
                <label htmlFor="" className="label">Title</label>
                <div className="description">Type your initiative title, type it in concise and exciting words</div>
                {
                    formDataLoad ? <span className="skeleton"></span> : 
                    <input type="text" className="form-control text" 
                        onChange={formik.handleChange}
                        onBlur={(e) => {
                            formik.handleBlur(e);

                            if(formik.values.Slug == '')
                            {
                                correctingEligibleSlug(e.currentTarget.value);
                            }
                        }}
                        value={formik.values.Title}
                        name="Title"
                    />
                }
            </div>
            <div className="form-group">
                <label htmlFor="" className="label">URL Identifier</label>
                <div className="description leading-text">
                    Type your preferred initiative identifier, this will help you advertise your initiative easily <br />
                    <span className="bold">
                        {props.config.base_url}/initiative/{formik.values.Slug || '...'}
                    </span>
                </div>
                {
                    formDataLoad || slugLoading ? <span className="skeleton"></span> : 
                    <input type="text" className="form-control text" 
                        onBlur={(e) => {
                            formik.handleBlur(e);
                            if(formik.values.Slug != e.currentTarget.value)
                            {
                                correctingEligibleSlug(e.currentTarget.value || formik.values.Title);
                            }
                        }}
                        defaultValue={formik.values.Slug}
                        name="Slug"
                    />
                }
            </div>
            <div className="form-group">
                <label htmlFor="" className="label">Description</label>
                <div className="description">Type description in 500 character to help people better understand your initiative</div>
                <div id="initiative-description"></div>
            </div>
            <div className="form-group">
                <label htmlFor="" className="label">Scope*</label>
                {
                    formDataLoad ? <span className="skeleton"></span> :
                    <div className="fancy-select">
                        <select value={formik.values.ScopeLevel} name="ScopeLevel" onChange={formik.handleChange} onBlur={formik.handleBlur}>
                            <option value="">Select Level</option>
                            {
                                props.config.EventLevel.map((event_level) => (
                                    <option value={event_level[0]} key={event_level[0]} checked={formik.values.ScopeLevel === event_level[0]}>
                                        {event_level[1]}
                                    </option>
                                ))
                            }
                        </select>
                    </div>
                }
            </div>
            <div className="form-group">
                <label htmlFor="" className="label">Related Interest</label>
                <div className="description">Choose interest that match with your initiative, this will affect your initiative appearance on search and feed</div>
                {
                    formDataLoad || initiativeInterests === false ? <span className="skeleton"></span> :
                    <Interests
                        onLoaded={() => {

                            setUpdatedSelectedInterest(initiativeInterests);
                        }} 
                        selectedInterests={initiativeInterests} 
                        selectInterest={(Sentinterests) => {
                            setUpdatedSelectedInterest(Sentinterests);
                        }}/>
                }
            </div>
            <div className="form-group" style={{display : 'none'}}>
                <label htmlFor="" className="label">Enable Multi-Role</label>
                <div className="description">Can initiative participants join in more than 1 role?</div>
                {
                    formDataLoad ? <span className="skeleton"></span> :
                    <label className="switch-button">
                        <input 
                            type="checkbox"
                            checked={ parseInt(formik.values.EnableMultirole)  === 1}
                            onChange={e => {
                                formik.setFieldValue('EnableMultirole', parseInt(formik.values.EnableMultirole) === 1 ? 0 : 1)
                            }}
                        />
                        <span className="slider round"></span>
                    </label>
                }
            </div>
            {
                !formDataLoad && managedPages.length > 0 &&
                <div className="form-group">
                    <label htmlFor="" className="label">Publish to Pages</label>
                    <div className="description">Do you want to publish this initiative into the page that you manage?</div>
                    {
                        formDataLoad ? <span className="skeleton"></span> :
                        <ul className="managed-pages">
                            {
                                managedPages.map((pages) => (
                                    <li key={pages.PageID}>
                                        <a href="#" className={`btn btn-mini ${selectedPages.indexOf(pages.PageID) > -1 ? 'btn-primary' : 'btn-reverse'}`} onClick={e => {
                                            e.preventDefault();

                                            if(selectedPages.indexOf(pages.PageID) < 0)
                                            {
                                                setSelectedPages(update(selectedPages, {
                                                    $push : [pages.PageID]
                                                }));
                                            }
                                            else
                                            {
                                                setSelectedPages(update(selectedPages, {
                                                    $splice : [[
                                                        selectedPages.indexOf(pages.PageID)
                                                        ,1
                                                    ]]
                                                }));
                                            }

                                        }}>{pages.PageName}</a>
                                    </li>
                                ))
                            }
                        </ul>
                    }
                </div>
            }
            {
                !formDataLoad && toProposedPages.length > 0 &&
                <div className="form-group">
                    <label htmlFor="" className="label">Proposed to Pages</label>
                    <div className="description">Do you want to proposed this initiative into a page ?</div>
                    {
                        formDataLoad ? <span className="skeleton"></span> :
                        <ul className="managed-pages flex flex-wrap">
                            {
                                toProposedPages.map((pages) => (
                                    <li key={pages.PageID} style={{padding : '6px'}}>
                                        <a href="#" className={`btn btn-mini ${selectedProposedPages.indexOf(pages.PageID) > -1 ? 'btn-primary' : 'btn-reverse'}`} onClick={e => {
                                            e.preventDefault();

                                            if(selectedProposedPages.indexOf(pages.PageID) < 0)
                                            {
                                                setSelectedProposedPages(update(selectedProposedPages, {
                                                    $push : [pages.PageID]
                                                }));
                                            }
                                            else
                                            {
                                                setSelectedProposedPages(update(selectedProposedPages, {
                                                    $splice : [[
                                                        selectedProposedPages.indexOf(pages.PageID)
                                                        ,1
                                                    ]]
                                                }));
                                            }

                                        }}>{pages.PageName}</a>
                                    </li>
                                ))
                            }
                        </ul>
                    }
                </div>
            }
            <div className="flex-flat form-group">
                <div>
                    <label htmlFor="" className="label">Start Date</label>
                    <div className="description">Time your initiative start</div>
                    {
                        formDataLoad ? <span className="skeleton"></span> :
                        <Datepicker
                            initialDate={formik.values.StartDate}
                            onSelect={(values) => {
                                formik.setFieldValue('StartDate', values)
                            }}
                        />

                    }
                </div>
                <div>
                    <label htmlFor="" className="label">End Date</label>
                    <div className="description">Expected end date</div>
                    {
                        formDataLoad ? <span className="skeleton"></span> :
                        <Datepicker
                            initialDate={formik.values.EndDate}
                            onSelect={(values) => {
                                formik.setFieldValue('EndDate', values)
                            }}
                        />
                    }
                </div>
            </div>
            <div className="form-group">
                <label htmlFor="" className="label">Poster / Ilustration / Activity Image</label>
                <div className="description">Give visual to your initiative to attract crowd to your initiative</div>
                {
                    filesContent.length ?
                    <div className="image-box mb-md rounded contain initiative-poster">
                        <img alt={filesContent[0].name} src={filesContent[0].content}></img>
                    </div> :
                    formik.values.PosterImage && <div className="image-box mb-md rounded contain initiative-poster">
                        <img src={formik.values.PosterImage}></img>
                    </div>

                }
                
                <div className="text-right">
                    {
                        formDataLoad ? <span className="skeleton"></span> :
                        <a className="btn btn-small btn-primary" onClick={(e) => { e.preventDefault(); openFileSelector()} }>Select Image</a>
                    }
                    {
                        (filesContent.length || formik.values.PosterImage) &&
                        <>
                            &nbsp;
                            <a className="btn btn-small btn-primary btn-reverse" onClick={(e) => { e.preventDefault(); clear(); formik.setFieldValue('PosterImage', '') } }>Remove Image</a>
                        </>
                    }
                </div>
                
            </div>
            <hr />
            <div className="flex-flat mt-4">
                <div className="text-right ">
                    {
                        updatedSelectedInterest !== false && <button type="submit" className='btn btn-orange'>{props.saveText || 'Next'}</button>
                    }
                </div>
            </div>
        </form>
    )
});

const popupEditInitiative = (initiative, onSaved) => {
    return new Promise((resolve) => {
        const EditInitaitivePopup = fancybox(
            <div className="w-800" key="edit-event">
                <div className="text-center">
                    <BlockHeader title="Edit Initiative" desc="Enter your iniitiative new basic information"/>
                </div>
                <EditInitiativeForm sentInitiative={initiative} onSave={(editedInitiative) => {
                    
                    resolve(editedInitiative);

                    EditInitaitivePopup.close();
        
                }}/>
            </div>
        )
    }).then((EditedInitiative) => {
        switch(EditedInitiative.InitiativeType)
        {
            case 'event':
                const EditInitaitiveEventPopup = fancybox(
                    <div className="w-800">
                        <div className="text-center">
                            <BlockHeader title="Event Information" desc="Update all necessary info for your event initiative"/>
                        </div>
                        <EditEventForm sentInitiative={EditedInitiative} onSave={(editedEvent) => {
                            onSaved(editedEvent);
                            
                            EditInitaitiveEventPopup.close();
                
                        }}/>
                    </div>
                )
                break;
            case 'research':
                const EditInitaitiveResearchPopup = fancybox(
                    <div className="w-800">
                        <div className="text-center">
                            <BlockHeader title="Research-Activity Information" desc="Update all necessary info for your research initiative"/>
                        </div>
                        <EditResearchForm sentInitiative={EditedInitiative} onSave={(editedResearch) => {
                            onSaved(editedResearch);
                            
                            EditInitaitiveResearchPopup.close();
                
                        }}/>
                    </div>
                )
                break;
            default:
                onSaved(EditedInitiative);

                EditInitaitiveEventPopup.close();

                break;
        }

    });
}

const popupFillDetail = (initiative) => {
        
    return new Promise((resolve) => {
        switch(initiative.InitiativeType)
        {
            case 'event':
                const EditInitaitiveEventPopup = fancybox(
                    <div className="w-800">
                        <div className="text-center">
                            <BlockHeader title="Event Information" desc="Update all necessary info for your event initiative"/>
                        </div>
                        <EditEventForm sentInitiative={initiative} onSave={(editedEvent) => {
                            resolve(editedEvent);

                            EditInitaitiveEventPopup.close();
                        }}/>
                    </div>
                )
                break;
            case 'research':
                const EditInitaitiveResearchPopup = fancybox(
                    <div className="w-800">
                        <div className="text-center">
                            <BlockHeader title="Research-Activity Information" desc="Update all necessary info for your research initiative"/>
                        </div>
                        <EditResearchForm sentInitiative={initiative} onSave={(editedResearch) => {
                            resolve(editedResearch);

                            EditInitaitiveResearchPopup.close();
                        }}/>
                    </div>
                )
                break;
            default:
                resolve();
                break;
        }
    })
}

const EditInitiativeButton = (props) => {
    const [initiative, setInitiative] = useState(false);

    useEffect(() => {
        if(initiative.InitiativeID != props.sentInitiative.InitiativeID)
        {
            setInitiative(props.sentInitiative);
        }
    }, [props.sentInitiative]);

    

    return(
        <Fragment>
            <button onClick={ e => {
                e.preventDefault();

                popupEditInitiative(initiative, (initiative) => {
                    props.onSave(initiative);
                });

            } } className={props.className}>{props.children}</button>
        </Fragment>
    )
}

const FillInitiativeButton = (props) => {

    

    return (
        <button className={props.className || ''} onClick={(e) => {
            e.preventDefault();

            popupFillDetail(props.initiative).then((editedInitiative => {
                props.onSaved(editedInitiative)
            }));

        }}>{props.children}</button>
    )
}

export { EditInitiativeForm, EditInitiativeButton, FillInitiativeButton, popupEditInitiative, popupFillDetail} 